import { BUSCAR_TIPOS_PRECO } from '../../actions/types'

const initialState = []

export default function reducerBuscarTiposPreco (state = initialState, action) {
  switch (action.type) {
    case BUSCAR_TIPOS_PRECO: {
      return action.payload.data;
    }
    default: {
      return state
    }
  }
}
